<template>
    <b-form-radio
        :button-variant="(outline ? 'outline-' : '') + color"
        :checked="checked"
        :class="['form-input-radio', {'placeholder-label': label === false }]"
        :disabled="disabled"
        :inline="inline"
        :name="name"
        :value="value"
        @click="$emit('click', $event)"
        @input="$emit('input', $event)"
    >
        <slot />
    </b-form-radio>
</template>

<script>
// Components.
import {BFormRadio} from 'bootstrap-vue'

export default {
    components: {BFormRadio},
    model: {
        event: 'input',
        prop: 'checked',
    },
    props: {
        checked: {type: [Boolean, Number, String]},
        color: {type: String},
        disabled: {type: Boolean},
        inline: {type: Boolean},
        label: {type: [String, Boolean], default: ''},
        name: {type: String},
        outline: {type: Boolean},
        value: {type: [Boolean, Number, String]},
    }
}
</script>